import { Component } from '@angular/core';
import { EventService } from '../service/event.service';
import { MatDialogRef } from '@angular/material/dialog';
import { SuccessDialogComponent } from '../success-dialog/success-dialog.component';
import { SubmitApplicantEvent } from '../service/events';

@Component({
    selector: 'app-submit-dialog',
    templateUrl: './submit-dialog.component.html',
    styleUrls: ['./submit-dialog.component.scss'],
    standalone: false
})
export class SubmitDialogComponent {

  constructor(private eventBus: EventService, public dialogRef: MatDialogRef<SuccessDialogComponent>) {
    dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onOkClick(): void {
    this.dialogRef.close();
    this.eventBus.emit(new SubmitApplicantEvent({}));
  }
}
